<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item" aria-current="page">
                <router-link to="/payrolls">{{ $t("payroll") }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
                [{{ payroll.OnYear }}/{{ $number(payroll.OnMonth, "00") }}]
            </li>
        </ol>
        <div class="x_header">
            <button type="button"
                    class="btn btn-outline-primary btn-sm no-bor"
                    @click="$router.go(-1)">
                <i class="fa fa-arrow-circle-o-left"></i> {{ $t("back") }}
            </button>
            <button v-if="payroll.Status != 'Completed'"
                    type="button"
                    class="btn btn-outline-primary btn-sm no-bor"
                    @click="onGenerate">
                <i class="fa fa-calculator"></i> {{ $t("payroll_generate") }}
            </button>
            <button v-if="payroll.Status == 'Posted'"
                    type="button"
                    class="btn btn-outline-primary btn-sm no-bor"
                    @click="onApprove">
                <i class="fa fa-check"></i> {{ $t("approval") }}
            </button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-bordered table-striped table-sm no-bor" style="width: auto">
                            <thead>
                                <tr>
                                    <th>{{ $t("no") }}</th>
                                    <th style="min-width: 100px;">{{ $t("code") }}</th>
                                    <th style="min-width: 150px;">{{ $t("name") }}</th>
                                    <th style="min-width: 135px;">{{ $t("card_no") }}</th>
                                    <th style="min-width: 50px;">{{ $t("sex") }}</th>
                                    <th style="min-width: 155px;">{{ $t("job") }}</th>
                                    <th style="min-width: 100px;">{{ $t("join_date") }}</th>
                                    <th style="min-width: 135px;">{{ $t("working_place") }}</th>
                                    <th style="min-width: 90px;">{{ $t("from_date") }}</th>
                                    <th style="min-width: 90px;">{{ $t("to_date") }}</th>
                                    <th style="min-width: 100px;" class="text-center">{{ $t("total_working_day") }}</th>
                                    <th style="min-width: 100px;" class="text-center">{{ $t("base_salary") }}</th>
                                    <th style="min-width: 100px;" class="text-center">{{ $t("phone_card_fee") }}</th>
                                    <th style="min-width: 100px;" class="text-center">{{ $t("over_time") }}</th>
                                    <th style="min-width: 120px;" class="text-center">{{ $t("crose_salary") }}</th>
                                    <th style="min-width: 100px;" class="text-center">{{ $t("loan") }}</th>
                                    <th style="min-width: 100px;" class="text-center">{{ $t("advance_salary") }}</th>
                                    <th style="min-width: 100px;" class="text-center">{{ $t("insur_deduce") }}</th>
                                    <th style="min-width: 100px;" class="text-center">{{ $t("other_deduce") }}</th>
                                    <th style="min-width: 100px;" class="text-center">{{ $t("salary") }}</th>
                                    <th v-if="payroll.Status!='Completed'" style="min-width: 70px;"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret, index) in employees" :key="index" :class="{active:ret.Checked}" @click="onSelected(ret)">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ ret.Employee.Num }}</td>
                                    <td>{{ ret.Employee.KhmerName }}</td>
                                    <td>{{ ret.Employee.CardNo }}</td>
                                    <td>{{ ret.Employee.Sex }}</td>
                                    <td>{{ ret.EmployeePayroll.Job }}</td>
                                    <td class="text-right">{{$format(ret.Employee.JoinDate,"DD-MMM-YY")}}</td>
                                    <td>{{ret.Branch != null? ret.Branch["Name"]: ""}}</td>
                                    <td class="text-right">{{$format(ret.MonthlyPayroll.FromDate,"DD-MM-YY")}}</td>
                                    <td class="text-right">{{$format(ret.MonthlyPayroll.ToDate,"DD-MM-YY")}}</td>
                                    <td class="text-right">{{$number(ret.EmployeePayroll.TotalWorkingDay,"0,0.[00]")}}</td>
                                    <td class="text-right">{{$dollar2(ret.EmployeePayroll.BasicSalary)}}</td>
                                    <td class="text-right">{{$dollar2(ret.EmployeePayroll.PhoneCard)}}</td>
                                    <td class="text-right">{{$dollar2(ret.EmployeePayroll.OverTime)}}</td>
                                    <td class="text-right">{{$dollar2(ret.EmployeePayroll.CroseSalary)}}</td>
                                    <td class="text-right">{{$dollar2(ret.EmployeePayroll.Loan)}}</td>
                                    <td class="text-right">{{$dollar2(ret.EmployeePayroll.AdvanceSalary)}}</td>
                                    <td class="text-right">{{$dollar2(ret.EmployeePayroll.InsurDeduce)}}</td>
                                    <td class="text-right">{{$dollar2(ret.EmployeePayroll.OtherDeduce)}}</td>
                                    <td class="text-right">{{$dollar2(ret.EmployeePayroll.NetSalary)}}</td>
                                    <td v-if="payroll.Status!='Completed'" class="text-center" style="padding: 3px;">
                                        <a href="javascript:void(0)" class="btn btn-danger btn-xs" @click="onDelete(ret.EmployeePayroll.Id)"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
                                        &nbsp;
                                        <a href="javascript:void(0)" class="btn btn-success btn-xs"><i class="fa fa-print" aria-hidden="true"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Swal from 'sweetalert2';
    export default {
        data() {
            return {
                payroll: {
                    Status: "Draft",
                },
                employees: [],
            };
        },
        created() {
            var id = this.$route.params.id;
            if (id !== undefined && id != null && id !== "") {
                this.findById(id);
            }
        },
        methods: {
            findById(id) {
                var loading = this.$loading.show();
                this.$api().post("payroll/find", { Id: id }).then((res) => {
                    if (this.$isValid(res)) {
                        this.payroll = res.data.Json.Payroll;
                        this.employees = res.data.Json.EmployeePayrolls;
                    }
                }).finally(function () { loading.hide(); });
            },
            onApprove: function () { },
            onGenerate: function () {
                var loading = this.$loading.show();
                var id = this.$route.params.id;
                this.$api().post("payroll/generate", { Id: id, CompanyId: this.$store.state.company.Id }).then((res) => {
                    if (this.$isValid(res)) {
                        this.findById(id);
                    }
                }).finally(function () { loading.hide(); });
            },
            onSelected: function (item) {
                this.employees.forEach(element => {
                    element.Checked = false;
                });
                item.Checked = true;
            },
            onDelete: function (id) {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        this.$api().post('payroll/delete', { Id: id }).then(res => {
                            if (this.$isValid(res)) {
                                this.findById(this.$route.params.id);
                            }
                        });
                    }
                });
            }
        }
    };
</script>
<style scoped>
    tbody > tr.active {
        background: #b3daff;
    }

    .btn-xs {
        padding: 3px 5px;
        color: #fff !important;
        border-radius: 3px;
        line-height: 0;
        cursor: pointer;
    }
</style>